import {DebouncedState, useDebouncedCallback} from 'use-debounce';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {endPresentationAction} from '../store/actions/chalkBoardElements.actions';

//  debounce to avoid multiple dispatches if slide has multiple errors
export function useDebouncePresentationState(): DebouncedState<() => void> {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useDebouncedCallback(() => {
        dispatch(endPresentationAction(navigate));
    }, 25);
}
